import React from "react"

import OptionButton from "../../common/components/OptionButton"
import QuestionReport from "./QuestionReport"

import { onResponse, onSubmit } from "../handlers"
import FreeForm from "./FreeForm"
import { SubmitOptionsButton } from "./SubmitButton"
import OptionContainer from "./OptionContainer"

// Select one
const Radio = ({ item, dispatch }) => (
  <div>
    <OptionContainer className="response-ul">
      {item.options
        .filter(option => option.preselected == null)
        .map((option, index) => (
          <OptionButton
            option={option}
            selected={
              item.response &&
              item.response.filter(x => x.token === option.token).length > 0
            }
            key={index}
            onClick={onResponse(item, dispatch)}
          />
        ))}
    </OptionContainer>
    {item.options.map(
      option =>
        option.isfreetext &&
        item.response.filter(x => x.token === option.token).length > 0 ? (
          <FreeForm />
        ) : null
    )}
    {item.options.map(
      option =>
        option.isfreetext &&
        item.response.filter(x => x.token === option.token).length > 0 ? (
          <SubmitOptionsButton onSubmit={onSubmit(item, dispatch)} />
        ) : null
    )}
    <QuestionReport />
  </div>
)

class RadioContainer extends React.Component {
  componentDidMount() {
    if (this.props.showMoreOptions) setTimeout(this.props.showMoreOptions, 1000)
  }

  componentWillUnmount() {
    if (this.props.hideMoreOptions) this.props.hideMoreOptions(false)
  }

  render() {
    return <Radio {...this.props} />
  }
}

export { RadioContainer as default }



// WEBPACK FOOTER //
// ./assets/interview/components/RadioResponse.js